import { Area, AreaChart, ResponsiveContainer, Tooltip } from "recharts";

// Sparkline صغير داخل كل كارت — 12 شهر · لا محاور · tooltip يعرض الشهر والكلفة.
export const TrendSparkline = ({ data = [], color = "#6366f1", currency = "USD" }) => {
  const points = data.map((cost, i) => ({ i, cost: Number(cost) || 0 }));
  const gradientId = `spark-${color.replace("#", "")}`;

  return (
    <div className="mt-3 h-14 w-full" data-testid="trend-sparkline">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={points} margin={{ top: 4, right: 2, left: 2, bottom: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.55} />
              <stop offset="100%" stopColor={color} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <Tooltip
            cursor={{ stroke: color, strokeOpacity: 0.4 }}
            contentStyle={{
              background: "rgba(0,0,0,0.85)", border: "none",
              borderRadius: 8, fontSize: 11, padding: "4px 8px",
            }}
            labelStyle={{ display: "none" }}
            formatter={(value, _n, item) => {
              const monthIdx = item?.payload?.i ?? 0;
              const offset = points.length - 1 - monthIdx;
              return [`${value.toFixed(4)} ${currency}`, `-${offset}m`];
            }}
          />
          <Area type="monotone" dataKey="cost" stroke={color} strokeWidth={1.5}
                fill={`url(#${gradientId})`} isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
